import {
  FETCH_DYNAMIC_TABLE_FAILURE,
  FETCH_DYNAMIC_TABLE_REQUEST,
  FETCH_DYNAMIC_TABLE_SUCCESS,
  PATCH_DYNAMIC_TABLE,
  PATCH_DYNAMIC_TABLE_SUCCESS,
} from "../actions/actionTypes"

const defaultConfig = {
  spendManagement: {
    confirmationNumber: { hidden: false },
  },
  spendManagementInvoices: {},
  schedulingConfirmations: {},
  shifts: {},
  timesheet: {},
  facility: {
    f_no_column_header: { hidden: false },
  },
  myFacility: {},
  spendManagementTimeEntries: {},
  invDocuments: {},
  locumsAnalytics: {},
  scheduledReports: {},
  candidates: {},
  landingPage: {},
  worksiteTable: {
    address: { hidden: true },
  },
}

const localStorageKey = "dynamicTableConfig"

// ✅ Load config safely
function loadConfigFromLocalStorage() {
  const storedConfig = localStorage.getItem(localStorageKey)
  try {
    const parsedConfig = JSON.parse(storedConfig)
    return parsedConfig && typeof parsedConfig === "object"
      ? parsedConfig
      : defaultConfig
  } catch (error) {
    console.error("Failed to parse localStorage JSON:", error)
    return defaultConfig
  }
}

// ✅ Save config safely
function saveConfigToLocalStorage(config) {
  localStorage.setItem(localStorageKey, JSON.stringify(config))
}

const initialState = {
  config: loadConfigFromLocalStorage(),
  loading: false,
  error: null,
  patching: false,
}

export function dynamicTableConfigReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_DYNAMIC_TABLE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      }

    case FETCH_DYNAMIC_TABLE_SUCCESS: {
      // ✅ Wrapped inside braces to avoid lexical declaration error
      const updatedConfigSuccess = {
        ...state.config,
        ...action.payload,
      }
      saveConfigToLocalStorage(updatedConfigSuccess)
      return {
        ...state,
        config: updatedConfigSuccess,
        loading: false,
      }
    }

    case FETCH_DYNAMIC_TABLE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }

    case PATCH_DYNAMIC_TABLE:
      return {
        ...state,
        patching: true,
      }

    case PATCH_DYNAMIC_TABLE_SUCCESS: {
      // ✅ Same here
      const updatedConfigPatch = {
        ...state.config,
        ...action.payload,
      }
      saveConfigToLocalStorage(updatedConfigPatch)
      return {
        ...state,
        config: updatedConfigPatch,
        patching: false,
      }
    }

    default:
      return state
  }
}

// ✅ Safe utility
export function columnHidden(fieldName, config) {
  return config?.[fieldName]?.hidden ?? false
}
